const DEFAULT_DEAL_NAME_LENGTH = 38;

export function getDealEntityDisplayName(
  name: string,
  maximumLength = DEFAULT_DEAL_NAME_LENGTH,
) {
  const normalized = name.trim().replace(/\s+/g, " ");
  if (normalized.length <= maximumLength) return normalized;

  const candidate = normalized.slice(0, maximumLength + 1);
  const lastWordBoundary = candidate.lastIndexOf(" ");
  const shortened = lastWordBoundary >= Math.floor(maximumLength * 0.6)
    ? candidate.slice(0, lastWordBoundary)
    : normalized.slice(0, maximumLength);
  return `${shortened.trimEnd()}…`;
}

export function getDealEntityTooltipText(name: string, detail?: string | null) {
  const displayName = getDealEntityDisplayName(name);
  const fullName = displayName === name.trim().replace(/\s+/g, " ")
    ? null
    : `Full Deal name: ${name.trim()}`;
  return [fullName, detail].filter(Boolean).join(" · ") || null;
}
